var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C8.34315 2 7 3.34315 7 5V9C7 10.6569 8.34315 12 10 12C11.6569 12 13 10.6569 13 9V5C13 3.34315 11.6569 2 10 2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4.55228 8 5 8.44772 5 9C5 11.7614 7.23858 14 10 14C12.7614 14 15 11.7614 15 9C15 8.44772 15.4477 8 16 8C16.5523 8 17 8.44772 17 9C17 12.5265 14.3923 15.4439 11 15.9291V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V15.9291C5.60771 15.4439 3 12.5265 3 9C3 8.44772 3.44772 8 4 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneBlack);
export default __webpack_public_path__ + "static/media/microphone-black.e4e84deb239f3810c109f43d11f97900.svg";
export { ForwardRef as ReactComponent };